<template>
    <slot
        :to
        :label
    >
        <NuxtLink :to>
            {{ label }}
        </NuxtLink>
    </slot>
</template>

<script setup>
const props = defineProps({
    link: {
        type: Object,
        default() {
            return {};
        }
    }
});

const { link } = toRefs(props);

const config = useRuntimeConfig();
const baseURL = config.public.baseURL;

const flatLink = computed(() => link.value?.craftLink ?? link.value);
const noBaseUrl = computed(() => flatLink.value?.value.replace(baseURL, ''));
const to = computed(() => `${noBaseUrl.value}${noBaseUrl.value?.urlSuffix ?? ''}`);
const label = computed(() => flatLink.value?.label ?? flatLink.value?.elementTitle);

/*
    Do not style this component
    It is a simple wrapper around NuxtLink to map data from the craftLink field.
    Styling this would make it difficult to maintain the consistency of the links.
*/
</script>
